import React, { useEffect, useState } from 'react';
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from 'components/SoftTypography';
import { baseURL } from 'utils/api';
import ReactQuill from 'react-quill';
import toast from 'react-hot-toast';
import { DeleteForeverOutlined } from '@mui/icons-material';
import Card from '@mui/material/Card';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import useMediaQuery from "@mui/material/useMediaQuery";


const HighlightsComponent = ({ email, id, userId }) => {

  const matches = useMediaQuery("(max-width:600px)");
  const [highlights, setHighlights] = useState([
    { key: '', value: '' }, // Initial highlight
  ]);
  const [loading, setLoading] = useState(false);
  const [madeChanges, setMadeChanges] = useState(false);
  const userTheme = useSelector((state) => state.commonSlice.theme);
  // const id = localStorage.getItem("id");

  const fetchHighlights = async () => {
    fetch(`${baseURL}/business-highlights-frontend/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setHighlights(data?.data?.highlights);
        } else {
          toast.error(data.message)
        }
      }
      ).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  }

  useEffect(() => {
    fetchHighlights();
  }, []);

  // Handlers for actions
  const handleAddHighlight = () => {
    setMadeChanges(true);
    setHighlights([...highlights, { key: '', value: '' }]);
  };

  const handleDelete = (index) => {
    setMadeChanges(true);
    const updatedHighlights = highlights.filter((_, i) => i !== index);
    setHighlights(updatedHighlights);
  };

  const AddHighlight = async (e) => {

    e.preventDefault();
    setLoading(true);

    fetch(`${baseURL}/create-business-highlights`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ highlightsArray: highlights, userId: userId, email: email, businessId: id })
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.status === 200) {
          toast.success(data.message);
          fetchHighlights();
        } else {
          toast.error(data.message);
        }
      }
      ).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  }



  return (
    <SoftBox
      sx={{
        margin: 'auto',
        width: '100%',
      }}
    >
      {highlights.map((highlight, index) => (
        <Card
          className="glassmorphism-card"
          key={index}
          elevation={1}
          sx={{
            marginBottom: 1,
            borderRadius: '8px',
            height: 'auto'
          }}
        >
        <SoftBox m={2}>
            <SoftTypography
              variant="caption"
            >
              Highlight key
            </SoftTypography>

            <SoftInput
              value={highlight.key}
              onChange={(e) => {
                const updatedHighlights = [...highlights];
                updatedHighlights[index].key = e.target.value;
                setHighlights(updatedHighlights);
                setMadeChanges(true);
              }
              }
              placeholder="Please enter your highlight key here" />
          </SoftBox>

          <SoftBox m={2}>
          <div className={`quill-wrapper ${userTheme === 'dark' ? 'dark-theme' : ''}`}>
            <ReactQuill
              value={highlight.value}
              onChange={(value) => {
                const updatedHighlights = [...highlights];
                updatedHighlights[index].value = value;
                setHighlights(updatedHighlights);
                setMadeChanges(true);
              }}
              className='quill'
              placeholder="Please enter your highlight value here"
              style={{ height: '200px' }}
            />
          </div>
          </SoftBox>

          <SoftBox sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2, 
            m: 2,
             mt:matches?10: 6
          }}>
            <SoftButton
              variant="gradient"
              width={200}
              onClick={() => handleDelete(index)}
              color="info"
            >
              Delete
              (<DeleteForeverOutlined />)
            </SoftButton>

          </SoftBox>
        </Card>
      ))}


      <SoftBox sx={{ display: 'flex', mt: 4 }}>
        {/* <Button variant="gradient" color="info">
            Save Changes
          </Button> */}
        <SoftButton
          variant="gradient"
          fullWidth
          sx={{ color: 'white', marginRight: 2 }}
          onClick={AddHighlight}
          color={madeChanges ? "info" : "light"}
          disabled={!madeChanges}
        >
          {
            loading ? <CircularProgress size={24} color='white' /> : 'Save Changes'
          }
        </SoftButton>
        <SoftButton
          variant="outlined"
          fullWidth
          onClick={handleAddHighlight}
          color="info"
        >
          Add More Highlights
        </SoftButton>
      </SoftBox>

    </SoftBox>
  );
};

export default HighlightsComponent;


